module.exports = __webpack_public_path__ + "static/img/twin-city-1.1dfc3fb2.png";